import { consumer, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  searchQueryHistory: string[];
  currentSearch: string;
  requestInProgress: boolean;
  queryResults: {
    searchQuery: string;
    matches: consumer.NavSuggestResponse;
  };
}

const initialState = {
  searchQueryHistory: [],
  currentSearch: '',
  requestInProgress: false,
  queryResults: {
    searchQuery: '',
    matches: {
      business: [],
      metroArea: [],
      metaTag: [],
    },
  },
};

export default function searchReducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload, request } = action;
  switch (type) {
    case AppConstants.CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        currentSearch: initialState.currentSearch,
        queryResults: initialState.queryResults,
      };
    case AppConstants.SEARCH_SET:
      return {
        ...state,
        currentSearch: payload,
      };
    case AppConstants.DISCOVER_AUTOCOMPLETE_NAV_SUGGESTIONS_STARTING:
      return {
        ...state,
        currentSearch: request.searchText,
        requestInProgress: true,
      };
    case AppConstants.DISCOVER_AUTOCOMPLETE_NAV_SUGGESTIONS_FAILED:
      return {
        ...state,
        requestInProgress: false,
      };
    case AppConstants.DISCOVER_AUTOCOMPLETE_NAV_SUGGESTIONS_DONE: {
      const parsedPayload = payloadToJSON<consumer.NavSuggestResponse>(payload);
      const updatedSearchResults = state.searchQueryHistory.slice();
      updatedSearchResults.push(request.searchText);
      return {
        ...state,
        requestInProgress: false,
        searchQueryHistory: updatedSearchResults,
        queryResults: {
          searchQuery: request.searchText,
          matches: parsedPayload,
        },
      };
    }
    default:
      return state;
  }
}
